var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.didLoadImageUrl)?_c('v-img',{attrs:{"src":_vm.imageUrl,"contain":"","max-width":"200","max-height":"80"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }